<template>
  <el-dialog
    :close-on-click-modal="false"
    title="结算工资"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
        <!-- 司机姓名 -->
        <span slot="carDriverName" slot-scope="prop">{{prop.form.carDriverName}}</span>
        <!-- 司机姓名 end -->
        <!-- 手机号码 -->
        <span slot="carDriverPhone" slot-scope="prop">{{prop.form.carDriverPhone}}</span>
        <!-- 手机号码 end -->
        <!-- 未结算金额 -->
        <span slot="uncheckAmount" slot-scope="prop" class="primary">{{prop.form.uncheckAmount}}</span>
        <!-- 未结算金额 end -->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  driverSalarySettlement,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '司机姓名',
            value: 'carDriverName',
            slot: true,
          },
          {
            label: '手机号码',
            value: 'carDriverPhone',
            slot: true,
          },
          {
            label: '未结算金额',
            value: 'uncheckAmount',
            slot: true,
          },
          {
            label: '结算金额',
            value: 'verificationSalary',
            type: 'input',
          },
        ],
        rules: { // 表单验证规则
          mobilePhone: [ // 司机手机号
            { required: true, message: '请输入司机手机号', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        item.uncheckAmount = item.realSalaryFeeDouble - item.paidSalaryFeeDouble;
        item.verificationSalary = item.realSalaryFeeDouble - item.paidSalaryFeeDouble;
        this.originData = item;
        this.$refs.customForm.setVal(item);
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await driverSalarySettlement({
        salaryId: this.originData.salaryId,
        ...form,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '结算成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
